import { useEffect } from "react";

export default function SignaturePage() {
  useEffect(() => { document.title = "Email podpis — Agent ŠVP"; }, []);

  const signatureHtml = `<table cellpadding="0" cellspacing="0" style="border-collapse: collapse; font-family: 'Segoe UI', Arial, sans-serif;">
  <tr>
    <td style="vertical-align: middle; padding-right: 14px; border-right: 2px solid #FFC72C;">
      <img src="https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/o4d55d23_logoagentsvp.webp" alt="Agent ŠVP" width="90" height="28" style="display: block; object-fit: contain;" />
    </td>
    <td style="vertical-align: top; padding-left: 14px;">
      <p style="margin: 0; font-size: 14px; font-weight: bold; color: #0F1B3D; line-height: 1.3;">Lucie Fišerová</p>
      <p style="margin: 0 0 6px; font-size: 11px; color: #6B7A99;">Koordinátor | #TouchOfLucky s.r.o.</p>
      <p style="margin: 0; font-size: 11px; color: #3D4F6F; line-height: 1.6;">Tel.: <a href="tel:+420739579961" style="color: #0049B3; text-decoration: none;">+420 739 579 961</a> | <a href="tel:+420739921359" style="color: #0049B3; text-decoration: none;">+420 739 921 359</a><br/>E-mail: <a href="mailto:lucie@agentsvp.cz" style="color: #0049B3; text-decoration: none;">lucie@agentsvp.cz</a> | Web: <a href="https://www.agentsvp.cz" style="color: #0049B3; text-decoration: none;">agentsvp.cz</a></p>
    </td>
  </tr>
</table>`;

  const handleCopy = () => {
    const el = document.getElementById('signature-preview');
    if (el) {
      const range = document.createRange();
      range.selectNodeContents(el);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      document.execCommand('copy');
      sel.removeAllRanges();
      alert('Podpis zkopírován! Vložte ho do Outlooku: Soubor → Možnosti → Pošta → Podpisy → Vložit (Ctrl+V)');
    }
  };

  const handleCopyHtml = () => {
    navigator.clipboard.writeText(signatureHtml);
    alert('HTML kód zkopírován do schránky!');
  };

  return (
    <div className="min-h-screen bg-[#F4F7FC] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-extrabold text-[#0F1B3D] mb-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Email podpis — Agent ŠVP
        </h1>
        <p className="text-[#6B7A99] mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
          Klikněte na tlačítko níže pro zkopírování podpisu. Poté ho vložte do nastavení podpisu v Outlooku.
        </p>

        {/* Buttons */}
        <div className="flex gap-4 mb-8">
          <button
            onClick={handleCopy}
            className="bg-[#0049B3] text-white px-6 py-3 rounded-xl font-bold text-sm hover:bg-[#003380] transition-colors"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Zkopírovat podpis (pro Outlook)
          </button>
          <button
            onClick={handleCopyHtml}
            className="bg-white text-[#0049B3] border-2 border-[#0049B3]/20 px-6 py-3 rounded-xl font-bold text-sm hover:bg-[#0049B3]/5 transition-colors"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Zkopírovat HTML kód
          </button>
        </div>

        {/* Preview */}
        <div className="bg-white rounded-2xl border border-[#E8EDF5] shadow-lg p-8">
          <p className="text-xs text-[#9CA3AF] uppercase tracking-wider font-semibold mb-4">Náhled podpisu</p>
          <div className="border-t border-[#E8EDF5] pt-6">
            <div id="signature-preview" dangerouslySetInnerHTML={{ __html: signatureHtml }} />
          </div>
        </div>

        {/* Instructions */}
        <div className="mt-8 bg-white rounded-2xl border border-[#E8EDF5] p-8">
          <h3 className="text-lg font-bold text-[#0F1B3D] mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Jak nastavit podpis v Outlooku
          </h3>
          <ol className="space-y-3 text-sm text-[#4A5B7A]" style={{ fontFamily: "'Inter', sans-serif" }}>
            <li><strong>1.</strong> Klikněte na <strong>„Zkopírovat podpis"</strong> výše</li>
            <li><strong>2.</strong> V Outlooku jděte do <strong>Soubor → Možnosti → Pošta → Podpisy</strong></li>
            <li><strong>3.</strong> Vytvořte nový podpis nebo upravte stávající</li>
            <li><strong>4.</strong> Do editoru podpisu vložte (<strong>Ctrl+V</strong>)</li>
            <li><strong>5.</strong> Uložte a nastavte jako výchozí podpis</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
